module.exports = __webpack_public_path__ + "media/images/metronic/portlet-plus-icon-white-a855e2dca1fe19506d14d69240291bb9.png";